<script>
export default {  
  name: 'HErrorBoundary',
  data: () => ({
    error: false,
    msg: ''
  }),
  errorCaptured(err, vm, info) {
    console.log(err, vm, info)
    this.msg = err?.message ?? 'no msg'
    this.error = true
  },
  render(h) {
    return this.error ? h('p', `Something went wrong: ${this.msg}`) : this.$slots.default?.[0]
  }
}
</script>